export interface PostCreateDraftListenerParams {
    form: HTMLFormElement;
    onInputOrChange: () => void;
    onExternalSaveRequest: () => void;
    onDisable: () => void;
    onPageHide: () => void;
    onVisibilityChange: () => void;
}

export class PostCreateDraftListener {
    public form: HTMLFormElement;

    public onInputOrChange: () => void;

    public onExternalSaveRequest: () => void;

    public onDisable: () => void;

    public onPageHide: () => void;

    public onVisibilityChange: () => void;

    public constructor(params: PostCreateDraftListenerParams) {
        this.form = params.form;
        this.onInputOrChange = params.onInputOrChange;
        this.onExternalSaveRequest = params.onExternalSaveRequest;
        this.onDisable = params.onDisable;
        this.onPageHide = params.onPageHide;
        this.onVisibilityChange = params.onVisibilityChange;
    }

    public register(): void {
        this.form.addEventListener("input", this.onInputOrChange, { capture: true });
        this.form.addEventListener("change", this.onInputOrChange, { capture: true });
        this.form.addEventListener("post:create:draft:save", this.onExternalSaveRequest);
        this.form.addEventListener("post:create:draft:disable", this.onDisable);

        window.addEventListener("pagehide", this.onPageHide);
        document.addEventListener("visibilitychange", this.onVisibilityChange);
    }

    public detach(): void {
        this.form.removeEventListener("input", this.onInputOrChange, { capture: true });
        this.form.removeEventListener("change", this.onInputOrChange, { capture: true });
        this.form.removeEventListener("post:create:draft:save", this.onExternalSaveRequest);
        this.form.removeEventListener("post:create:draft:disable", this.onDisable);

        window.removeEventListener("pagehide", this.onPageHide);
        document.removeEventListener("visibilitychange", this.onVisibilityChange);
    }
}
